import Api from "./Api";
import Utils from "../utilities/Utils";
import { BizzeyFile, Task } from "../types";
import SearchHelper from "../helpers/SearchHelper";

export default class FinancialYearController extends Api {
  static getFinancialYears(params: object) {
    return fetch(
      `/api/financial_years?${SearchHelper.getQueryString(params)}`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.token,
        },
        credentials: "same-origin",
      }
    ).then((res) => res.json());
  }

  static create(financialYear: Task) {
    return fetch("/api/financial_years", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: this.token,
      },
      credentials: "same-origin",
      body: JSON.stringify({ financial_year: financialYear }),
    }).then((res) => res.json());
  }

  static update(financialYear: Task) {
    return fetch(`/api/financial_years/${financialYear.id}`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: this.token,
      },
      credentials: "same-origin",
      body: JSON.stringify({ financial_year: financialYear }),
    }).then((res) => res.json());
  }

  static delete(id: string) {
    return fetch(`/api/financial_years/${id}`, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: this.token,
      },
      credentials: "same-origin",
    }).then((res) => res.json());
  }

  static getForm(params: object) {
    return fetch(`/api/financial_years/form?${Utils.encodeQueryData(params)}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: this.token,
      },
      credentials: "same-origin",
    }).then((res) => res.json());
  }
}
